import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from "@angular/core";
import { FormControl, UntypedFormGroup } from "@angular/forms";
import { FieldConfig } from "../field.interface";
import { FloatLabelType } from "@angular/material/form-field";

@Component({
  selector: "calsoft-input",
  templateUrl: "./input.component.html",
  styleUrls: ['./input.component.scss']
})
export class InputComponent implements OnInit {
  @Input() field: FieldConfig;
  @Input() customField13: any = 0;
  @Input() group: UntypedFormGroup;
  @Input() type: any;
  @Input() whiteFields : any;
  @Output() valueChange = new EventEmitter<any>();
  inputLength: number = 0;
  display: boolean = false;
  resultvalue: boolean = false;
  hideRequired: boolean = false;
  constructor() { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.field && changes.field.currentValue) {
      const control = this.group.get(this.field.name);
      if (control) {
        control.valueChanges.subscribe(value => {
          this.inputLength = value?.length;
        });
      }
    }
  }

  getFloatLabelValue(): FloatLabelType {
    return this.floatLabelControl.value || 'auto';
  }
  hideRequiredControl = new FormControl(false);
  floatLabelControl = new FormControl('auto' as FloatLabelType)
  ngOnInit() {
    console.log("the comming whitefiled is",this.whiteFields);
    
    this.hideRequiredControl.valueChanges.subscribe(value => {
      this.hideRequired = value;
    });
    this.floatLabelControl.valueChanges.subscribe(value => {
      this.floatLabel = value || 'auto';
    });
    const control = this.group.get(this.field.name);
    if (control) {
      control.valueChanges.subscribe(value => {
        this.inputLength = value?.length;
     //   this.checkCondition();
      });
    }

    if (this.group != undefined) {
      this.display = true;
    }
  }


  floatLabel: string = 'auto';

  isRequired(fieldName: string): boolean {
    const control = this.group.get(fieldName);
    return control && control.hasError('required');
  }



  setValue(value: any) {
    if (this.group.get(this.field.name)?.valid) {
      this.group.get(this.field.name).setValue(value);
      this.valueChange.emit( this.field.name);
    } else {
      console.error('Form control is invalid');
    }
  }
}
